export const storeNamespace = namespaceName => path =>
	`${namespaceName}/${path}`;

export default {};



// WEBPACK FOOTER //
// ./src/modules/shared/utils/store.utils.js